module.exports = __webpack_public_path__ + "static/media/rectangle-view-on.b11df6eb.svg";